import DereferenceError from "./DereferenceError.mjs";
/**
 * @public
 */
class MaximumDereferenceDepthError extends DereferenceError {}
export default MaximumDereferenceDepthError;